import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierLaneRateQuickInfo extends Layout {
    panelCommitments: Panel;
    panelContent: Panel;
    sourceCarrierLaneRate: DataSource;
    textboxCarrierRateId: Textbox;
    textboxCommitmentAmount: Textbox;
    textboxCommitmentFrequency: Textbox;
    textboxCommitmentsMet: Textbox;
    textboxCommitmentsOffered: Textbox;
    textboxDescription: Textbox;
}
